import { useTranslation } from "react-i18next";
import { Typography, makeStyles } from "@material-ui/core";
import { StorageNotificationTemplate, TypeConfig } from "../typeConfig";

type Props = {
  tc: TypeConfig;
  template: StorageNotificationTemplate;
};

export default function TemplateViewSectionContent({ tc, template }: Props) {
  const classes = useStyles();
  const { t } = useTranslation("storage");
  const sectionData = template[
    tc.formKey as keyof StorageNotificationTemplate
  ] as Record<string, unknown>;

  const activeFields = tc.fields.filter(field => {
    if (field.sectionKey) return sectionData[field.sectionKey] === true;
    return field.key in sectionData;
  });

  const activeToggles = (tc.toggles || []).filter(
    toggle => sectionData[toggle.key] === true
  );

  if (activeFields.length === 0 && activeToggles.length === 0) {
    return (
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.noFields}
      >
        {t("notificationTemplates.view.noCustomFields")}
      </Typography>
    );
  }

  return (
    <div className={classes.fields}>
      {activeFields.map(field => {
        const value = sectionData[field.key];
        return (
          <div key={field.key} className={classes.field}>
            <Typography
              variant="caption"
              color="textSecondary"
              className={classes.fieldLabel}
            >
              {t(`notificationTemplates.form.field.${field.key}`)}
            </Typography>
            <Typography variant="body2" className={classes.fieldValue}>
              {typeof value === "string" ? value : "—"}
            </Typography>
          </div>
        );
      })}
      {activeToggles.map(toggle => (
        <div key={toggle.key} className={classes.field}>
          <Typography variant="body2" className={classes.fieldValue}>
            {t(`notificationTemplates.view.toggle.${toggle.key}`)}
          </Typography>
        </div>
      ))}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  noFields: {
    fontStyle: "italic",
  },
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  field: {
    padding: "8px 12px",
    backgroundColor: "#f9fafb",
    borderRadius: 6,
    borderLeft: `3px solid ${theme.palette.primary.light}`,
  },
  fieldLabel: {
    display: "block",
    marginBottom: 2,
    fontWeight: 600,
  },
  fieldValue: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
}));
